import React from 'react'
import { AppBar, Box, IconButton, makeStyles, Toolbar, Typography } from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import RefreshIcon from '@material-ui/icons/Refresh'
import HelpDrawer from '../help/HelpDrawer'
import NotificationBell from './NotificationBell'

const useStyles = makeStyles(() => ({
  bar: {
    background: 'linear-gradient(135deg, #1a237e 0%, #4b3fa7 100%)',
    boxShadow: '0 2px 10px rgba(20,30,80,.25)',
  },
}))

// نوار بالای نازک — فقط عنوان صفحه + دکمهٔ منو (موبایل)
const MenuAppBar = (props) => {
  const classes = useStyles()
  return (
    <AppBar position="sticky" className={classes.bar}>
      <Toolbar style={{ minHeight: 56, paddingLeft: 10, paddingRight: 10 }}>
        {props.onOpenMenu && (
          <IconButton color="inherit" edge="start" onClick={props.onOpenMenu} style={{ marginLeft: 6 }} data-tour="menu-toggle">
            <MenuIcon />
          </IconButton>
        )}
        <Typography variant="h6" style={{ fontSize: 15.5, fontWeight: 700 }}>
          {props.title}
        </Typography>
        <Box style={{ flex: 1 }} />
        <IconButton color="inherit" title="به‌روزرسانی همین صفحه" aria-label="refresh"
          onClick={() => {
            // بعد از رفرش به همان صفحه برگرد (حتی اگر روتر به داشبورد بپرد)
            try { sessionStorage.setItem('afRefreshTo', window.location.pathname + window.location.search) } catch (e) { /* noop */ }
            window.location.reload()
          }}>
          <RefreshIcon />
        </IconButton>
        <NotificationBell />
        <HelpDrawer />
      </Toolbar>
    </AppBar>
  )
}

export default MenuAppBar
